import { Box, Button, Flex, Heading, Input } from "@chakra-ui/react";
import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../Contexts/AuthContextProvider";

const Login = () => {
  const [email, setEmail] = useState("");
  const [pass, setPassword] = useState("");
  const { loginUser, token } = React.useContext(AuthContext);

  const handleSubmit = () => {
    const payload = {
      email,
      pass,
    };
    // console.log(payload)

    fetch("https://dull-tan-drill-gear.cyclic.app/users/login", {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.token) {
          loginUser(res.token);
          localStorage.setItem("token", JSON.stringify(res.token));
        } else {
          alert(res.msg);
        }
      })
      .catch((e) => console.log(e));
  };
  // console.log(token)
  if (token) {
    alert(" Login Successfull");
    return <Navigate to="/recipes" />;
  } else {
    return (
      <Box>
        <Heading as={"h5"} size="lg" textAlign={"center"} m={"50px"}>
          Login Page
        </Heading>
        <Flex
          direction={"column"}
          gap={"20px"}
          w={"25%"}
          m={"auto"}
          padding={"30px"}
          borderRadius={"20px"}
          boxShadow={"rgba(0, 0, 0, 0.35) 0px 5px 15px"}
        >
          <Input
            type={"text"}
            placeholder={"Enter Email"}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <Input
            type={"password"}
            placeholder={"Enter Password"}
            value={pass}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
          <Button onClick={handleSubmit} colorScheme="teal" variant={"outline"}>
            Login
          </Button>
        </Flex>
      </Box>
    );
  }
};

export default Login;
